import axios, { InternalAxiosRequestConfig } from 'axios';
import { AGraphApiSettings } from '../Base';
import { AW_VARNISH_API_URL } from './Constants';

export const awContentSettings: AGraphApiSettings = {};
export const awContentApi = axios.create();

awContentApi.interceptors.request.use((config) => {
  const baseURL = AW_VARNISH_API_URL;
  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
  };

  return updatedConfig;
});
